import { Outlet } from "react-router-dom";
import HeaderScreen from "./header";
import FooterScreen from "./footer";

const Layout = () => {
    return (
        <>
            <HeaderScreen />
            <div>
                <Outlet /> 
            </div>
            <FooterScreen />
        </>
    );
};

export default Layout;